function discountCalc(val, total) {
    let discount = total - val;
    let discountPer = discount / total * 100;
    return Math.round(discountPer, 2);
}
export default discountCalc